import algoliasearch from 'algoliasearch/lite';

export const searchClient = algoliasearch(
  '3CFULMFIDW',
  'cdfadff49930ec4dc3327807edd10b8c'
);
